window.brandAssetHelper = {
    fetchAsDataUri: async function (url) {
        if (!url) {
            return "";
        }
        try {
            var response = await fetch(url, {
                method: "GET",
                referrerPolicy: "no-referrer",
                credentials: "omit",
                cache: "no-store"
            });
            if (!response.ok) {
                return "";
            }
            var blob = await response.blob();
            return await new Promise(function (resolve) {
                var reader = new FileReader();
                reader.onloadend = function () { resolve(reader.result || ""); };
                reader.onerror = function () { resolve(""); };
                reader.readAsDataURL(blob);
            });
        } catch (e) {
            return "";
        }
    }
};


